<!--  -->
<template>
  <div
    :class="['position-btn', this_isLocation ? 'on' : '']"
    @click="onOff()"
  ></div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      this_isLocation: false, //成功展示定位点了
      geolocation: null, //定位实例
      locationMarker: null, //定位点
      options: { timeout: 8000 },
      curPositionInterval: null, //微信中获取定位的定时器
      position: null, //获取的点位
    };
  },
  props: {
    isLocation: {
      type: Boolean,
      default: function () {
        return true;
      },
    },
    scenicBound: {
      type: Array,
    },
    mapObj: {
      type: Object,
    },
    needZoomTo: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    isLocation(newV, oldV) {
      // console.log(newV + "----" + oldV);
      if (newV == true) {
        // 初始默认持续获取当前定位
        // this.watchCurPosition();
        // if (this.GLOBAL.isWx) {
        //   this.wxGetPositionOnce();
        // } else {
        this.geolocation.getLocation(
          this.showPosition,
          this.showErr,
          this.options
        );
        // }
      }
    },
  },
  //方法集合
  methods: {
    // 持续获取当前定位
    watchCurPosition() {
      console.log("持续定位开始");
      let that = this;
      that.geolocation.watchPosition(showPosition);
      function showPosition(position) {
        console.log(position);
        let lnglat = new AMap.LngLat(position.lng, position.lat);
        sessionStorage.setItem("lng", position.lng);
        sessionStorage.setItem("lat", position.lat);
        // console.log(lnglat);
        if (that.scenicBound.length > 0) {
          console.log("有电子围栏");
          if (that.isInBound(position.lat, position.lng, that.scenicBound)) {
            console.log("在电子围栏内");
          } else {
            console.log("不在电子围栏内");
            Toast({
              message: "您当前不在景区范围内",
              position: "bottom",
            });
            return;
          }
        } else {
          console.log("没有电子围栏");
        }
        if (that.this_isLocation) {
          that.locationMarker.setPosition(lnglat);
        } else {
          that.this_isLocation = true;
          that.locationMarker = new AMap.Marker({
            position: lnglat,
            offset: new AMap.Pixel(-8, -16),
            content: "<div class='curMarker'></div>",
            zIndex: 200,
          });
          that.mapObj.add(that.locationMarker);
        }
      }
    },
    // 是否在一个电子围栏内
    isInBound(lat, lng, bound) {
      let polygon = new AMap.Polygon({
        map: this.mapObj,
        path: bound,
        strokeColor: "#fefefe", //线颜色
        strokeOpacity: 1, //线透明度
        strokeWeight: 3, //线宽
        fillColor: "#333", //填充色
        fillOpacity: 0, //填充透明度
      });
      this.mapObj.remove(polygon);
      // mapObj.add(polygon)
      if (polygon.contains(new AMap.LngLat(lng, lat))) {
        return true;
      } else {
        return false;
      }
    },
    // 定位开关
    onOff() {
      if (this.this_isLocation) {
        // 关
        this.clearWatchCurPosition();
      } else {
        // 开
        // if (this.GLOBAL.isWx) {
        //   this.wxGetPositionOnce();
        // } else {
        this.geolocation.getLocation(
          this.showPosition,
          this.showErr,
          this.options
        );
        // }
      }
    },
    // 微信中 单次定位
    wxGetPositionOnce() {
      let that = this;
      this.$wechat.getLocation({
        type: "gcj02", // 默认为 wgs84 返回 gps 坐标，gcj02 返回可用于 wx.openLocation 的坐标
        success: function (res) {
          // success
          console.log(res);
          let lat = res.latitude;
          let lng = res.longitude;
          sessionStorage.setItem("lng", lng);
          sessionStorage.setItem("lat", lat);
          if (that.scenicBound.length > 0) {
            console.log("有电子围栏");
            if (that.isInBound(lat, lng, that.scenicBound)) {
              console.log("在景区内");
              // 用户在景区内就以用户为中心点
              that.mapObj.setCenter([lng, lat]);
            } else {
              Toast({
                message: "您当前不在景区范围内",
                position: "bottom",
              });
              console.log("不在景区内");
              return;
            }
          } else {
            console.log("没有电子围栏");
          }
          that.wxWatchCurPosition();
        },
        fail: function () {
          // fail
        },
        complete: function () {
          // complete
        },
      });
    },
    // 微信中连续定位事件
    wxWatchCurPosition() {
      let that = this;
      this.curPositionInterval = setInterval(function () {
        console.log("当前微信定位定时器中");
        that.$wechat.getLocation({
          type: "gcj02", // 默认为 wgs84 返回 gps 坐标，gcj02 返回可用于 wx.openLocation 的坐标
          success: function (res) {
            // success
            console.log(res);
            let lat = res.latitude;
            let lng = res.longitude;
            // lat+=0.001;
            sessionStorage.setItem("lng", lng);
            sessionStorage.setItem("lat", lat);
            if (that.scenicBound.length > 0) {
              console.log("有电子围栏");
              if (that.isInBound(lat, lng, that.scenicBound)) {
                console.log("在电子围栏内");
              } else {
                console.log("不在电子围栏内");

                Toast({
                  message: "您当前不在景区范围内",
                  position: "bottom",
                });
                that.clearWatchCurPosition();
                return;
              }
            } else {
              console.log("没有电子围栏");
            }
            if (that.this_isLocation) {
              that.locationMarker.setPosition([lng, lat]);
            } else {
              that.this_isLocation = true;
              that.locationMarker = new AMap.Marker({
                position: new AMap.LngLat(lng, lat),
                offset: new AMap.Pixel(-8, -16),
                content: "<div class='curMarker'></div>",
                zIndex: 200,
              });
              that.mapObj.add(that.locationMarker);
            }
          },
          fail: function () {
            // fail
          },
          complete: function () {
            // complete
          },
        });
        // thislat += 0.01;
      }, 1000);
    },
    // 单次定位 获取定位成功事件
    showPosition(position) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.position = [position.lng, position.lat];
      this.toParent();
      console.log("首次定位成功");
      // this.mapObj.setCenter([position.lng, position.lat]);
      sessionStorage.setItem("lng", position.lng);
      sessionStorage.setItem("lat", position.lat);
      // 获取定位成功后 准备开始持续定位
      // // 先判断是否要判断电子围栏
      // if (this.scenicBound) {
      //   console.log("有电子围栏");
      // } else {
      //   console.log("没有电子围栏");
      // }
      if (this.scenicBound.length > 0) {
        console.log("有电子围栏");
        if (this.isInBound(position.lat, position.lng, this.scenicBound)) {
          console.log("在电子围栏内");
          // 用户在景区内就以用户为中心点
          this.mapObj.setCenter([position.lng, position.lat]);
        } else {
          console.log("不在电子围栏内");
          Toast({
            message: "您当前不在景区范围内",
            position: "bottom",
          });
          return;
        }
      } else {
        console.log("没有电子围栏");
      }
      this.watchCurPosition();
    },
    // 单次定位 获取定位失败事件
    showErr() {
      console.log("首次定位失败");
      Toast({
        message: "获取定位失败,请手动打开右下角定位",
        position: "bottom",
      });
    },
    // 停止获取当前定位
    clearWatchCurPosition() {
      console.log("off");
      // if (this.GLOBAL.isWx) {
      //   clearInterval(this.curPositionInterval);
      //   this.curPositionInterval = null;
      // } else {
      this.geolocation.clearWatch();
      // }
      if (this.locationMarker != null) {
        this.mapObj.remove(this.locationMarker);
        this.this_isLocation = false;
        this.locationMarker = null;
      }
    },
    toParent() {
      console.log(this.position);
      this.$emit("event", this.position);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // if (this.GLOBAL.isWx) {
    // } else {
    this.geolocation = new qq.maps.Geolocation(
      "3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM",
      "myweb"
    );
    console.log(this.geolocation);
    // }
  },
  beforeCreate() {}, //生命周期 - 创建之前

  updated() {}, //生命周期 - 更新之后  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  beforeDestroy() {
    console.log("销毁定位监听");
    this.clearWatchCurPosition();
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.position-btn {
  width: 2.64rem;
  height: 2.64rem;
  border-radius: 50%;
  opacity: 0.96;
  background: #fff;
  position: absolute;
  bottom: 8.7rem;
  right: 1.32rem;
  z-index: 0;
  display: block;
  background-image: url("../../../static/images/icon_location.svg");
  background-repeat: no-repeat;
  background-size: 100%;
  box-shadow: 0rem 0.01rem 0.04rem 0rem rgba(0, 0, 0, 0.25);

  &.on {
    background-image: url("../../../static/images/icon_location_on.svg");
  }
}
</style>
<style>
.curMarker {
  width: 16px;
  height: 16px;
  background: url("../../../static/images/loacation.png") no-repeat;
  background-size: 100%;
}
</style>